exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".container__UserSelectionComponent-module___3shv0 {\n    position: relative;\n    width: 100%;\n}\n.flexContainer__UserSelectionComponent-module___1TVMQ {\n    display: flex;\n    gap:10px;\n    background-color: white;\n     height: 36px; \n     width: 100% ;\n}\n\n.button__UserSelectionComponent-module___1sTQE {\n    min-width: 55px;\n}\n\n.input__UserSelectionComponent-module___1m8Tw {\n    height: 38px;\n}", ""]);

// Exports
exports.locals = {
	"container": "container__UserSelectionComponent-module___3shv0",
	"flexContainer": "flexContainer__UserSelectionComponent-module___1TVMQ",
	"button": "button__UserSelectionComponent-module___1sTQE",
	"input": "input__UserSelectionComponent-module___1m8Tw"
};